import React from 'react';
// Importación actualizada de todos los íconos necesarios para las funciones Premium
import { Activity, Volume2, Leaf, Settings, FileWarning, Map, Crosshair, Shield, Clock, Smartphone, Users, Zap } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <Activity size={32} />,
      title: 'Telemetría Avanzada y Comandos OTA',
      description: 'Más que GPS. Monitorea temperatura, ignición y envía comandos remotos (como apagado de motor o activación de sirenas) en tiempo real.'
    },
    {
      icon: <Volume2 size={32} />,
      title: 'Centro de Monitoreo TTS',
      description: 'Nuestro motor Text-to-Speech (voz robótica) leerá las alertas críticas en voz alta automáticamente en tu centro de control.'
    },
    {
      icon: <Leaf size={32} />,
      title: 'Auditoría Eco-Driving',
      description: 'Evalúa los hábitos de tus conductores. Detecta aceleraciones bruscas, frenadas de emergencia y excesos de velocidad.'
    },
    {
      icon: <Settings size={32} />,
      title: 'Odómetro Virtual Inteligente',
      description: 'Olvídate de revisar el tablero. El sistema calcula y sincroniza matemáticamente el kilometraje exacto de cada vehículo.'
    },
    {
      icon: <FileWarning size={32} />,
      title: 'Semáforo de Vencimientos',
      description: 'Evita multas y paralizaciones. Control visual de colores para pólizas de seguro, licencias y mantenimientos próximos a vencer.'
    },
    {
      icon: <Map size={32} />,
      title: 'Control Perimetral y Horarios',
      description: 'Crea geocercas poligonales y establece horarios estrictos de circulación. Recibe alertas si un vehículo se mueve fuera de su turno.'
    },
    {
      icon: <Crosshair size={32} />,
      title: 'Modo Auto-Seguimiento',
      description: 'Fija un objetivo en el mapa y la cámara lo perseguirá automáticamente por toda la ciudad, ideal para operaciones tácticas.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Permisos Granulares',
      description: 'Control de seguridad nivel empresarial. Define exactamente qué módulos, reportes o comandos puede ejecutar cada usuario.'
    },
    {
      icon: <Clock size={32} />,
      title: 'Auditoría Forense de Rutas',
      description: 'Reconstruye cualquier recorrido en el tiempo, evalúa paradas y exporta los trazos en formatos forenses como KML y GeoJSON.'
    },
    {
      icon: <Smartphone size={32} />,
      title: 'Plataforma Multi-Dispositivo',
      description: 'Control total de tu flota desde computadoras, tablets o nuestra aplicación móvil optimizada, sin perder funcionalidades.'
    },
    {
      icon: <Users size={32} />,
      title: 'Gestión Integral de Flota',
      description: 'Expediente digital completo: administra dispositivos, tarjetas SIM, grupos de clientes y asignaciones de conductores.'
    },
    {
      icon: <Zap size={32} />,
      title: 'Arquitectura de Alta Velocidad',
      description: 'Diseñada para soportar cientos de vehículos simultáneamente sin latencia, garantizando un flujo de datos ininterrumpido.'
    }
  ];

  return (
    <section id="features" className="section section-alt">
      <div className="container">
        <h2 className="section-title">Características Destacadas</h2>
        <p className="section-subtitle">
          VillaTracking ofrece una solución completa para el monitoreo y gestión de tu flota vehicular, 
          con herramientas avanzadas diseñadas para mejorar la eficiencia y seguridad.
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;